/* eslint-disable */
export default {
  eula: 'エンドユーザーライセンス契約',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
